module.exports = __webpack_public_path__ + "static/media/bg_video_web.2a3a3924.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/Components/bg_video_web.mp4
// module id = 43
// module chunks = 0